import React, { useState } from "react";
import styled from "styled-components";
import { IMusic } from "../../../common/commonTypes";
import Modal, { IModalProps } from "../../../common/components/Modal/Modal";
import { useTranslation } from "react-i18next";
import MusicAbout from "../../Marketplace/Asset/MusicAbout";
import MusicDetails from "../../Marketplace/Asset/MusicDetails";
import Sections from "../../../common/components/Sections/Sections";
import Typography from "../../../common/components/Typography/Typography";
import AssetContentLayout from "../../Marketplace/Asset/AssetContentLayout";
import { IMAGE_SIZES } from "../../../constants/imageSizes";
import LocalPlayerCard from "../../../common/components/LocalPlayerCard/LocalPlayerCard";

const StyledModal = styled(Modal)`
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 90vw;
    max-width: 90vw;
    max-height: 90vh;
  }
`;

const Container = styled.div`
  margin: 0 auto;
`;

interface Props extends IModalProps {
  music: IMusic;
}

const FullPreviewModal = ({ music, isOpen, onClose }: Props) => {
  const { t } = useTranslation();
  const [activeSectionId, setActiveSectionId] = useState<string | number>();

  const sections = [
    {
      id: "about",
      title: t("asset-tabs-about"),
      content: <MusicAbout music={music} />,
    },
    {
      id: "info",
      title: t("asset-tabs-information"),
      content: <MusicDetails music={music} />,
    },
  ];

  return (
    <StyledModal isOpen={isOpen} onClose={onClose}>
      <Container className="main-container">
        <AssetContentLayout
          player={
            <LocalPlayerCard
              music={music}
              coverResizeWidth={IMAGE_SIZES.trackCoverArt.big}
            />
          }
          bidInfo={
            <Typography heading size="lg" weight="500">
              {music?.title}
            </Typography>
          }
          musicInfo={
            <Sections
              sections={sections}
              activeSectionId={activeSectionId}
              setActiveSectionId={setActiveSectionId}
            />
          }
        />
      </Container>
    </StyledModal>
  );
};

export default FullPreviewModal;
